export default __webpack_public_path__ + "static/media/werking-wheather-3.381974cd.JPG";